import { initialState, IState } from 'modules/event-manager/event-manager.reducer';
import { SWITCH_PREVIEW_STATE_HOST, SwitchPreviewStateAction } from '@sitegen/common/types/root-actions';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

export const event = (state: IState = initialState, action: SwitchPreviewStateAction): IState => {
    switch (action.type) {
    case SWITCH_PREVIEW_STATE_HOST:
        return {
            ...state,
            error: { type: action.payload },
            data: {
                code: 'testsitegen',
                name: 'TestSitegen',
                platforms: [
                    {
                        platform: PLATFORM_TYPES.PC,
                        url: null,
                        startDate: '2018-08-14T15:31:43',
                        endDate: '2018-11-22T15:31:43',
                        preloadDate: '2018-10-17T15:31:43'
                    },
                    {
                        platform: PLATFORM_TYPES.PS4,
                        url: 'http://www.google.com',
                        startDate: '2018-09-05T15:48:28',
                        endDate: '2018-11-08T15:48:28',
                        preloadDate: '2018-08-31T15:48:28'
                    },
                    {
                        platform: PLATFORM_TYPES.XONE,
                        url: 'http://www.yahoo.com',
                        startDate: '2018-09-06T15:49:27',
                        endDate: '2018-10-25T15:49:27',
                        preloadDate: '2018-09-05T15:49:27'
                    }
                ]
            }
        };
    default: {
        return state;
    }
    }
};

export default event;
